import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { lenisScroll } from 'helpers/smooth-scroll'

const calculatorBlock = {
  init(): void {
    gsap.registerPlugin(ScrollTrigger)

    document.querySelectorAll<HTMLElement>('.calculator-block').forEach((target: HTMLElement) => {
      this.handleCalculatorBlock(target)
    })
  },

  handleCalculatorBlock(target): void {
    const allowedDomains = [/^https?:\/\/localhost:(3000|3001)$/, /^https?:\/\/(?:.*\.)?lsr\.is$/]

    const el = {
      iframeContainer: target.querySelector('iframe').parentElement,
    }

    const method = {
      init(): void {
        window.addEventListener('message', (event) => {
          const originAllowed = allowedDomains.some((pattern) =>
            typeof pattern === 'string' ? pattern === event.origin : pattern.test(event.origin)
          )

          if (originAllowed) {
            if (event.data.source === 'react-devtools-content-script') {
              return
            }

            if (event.data.iframeHeight) {
              method.setHeight(event.data)
            }

            if (event.data.scrollIntoView) {
              method.scrollIntoView(event.data)
            }
          }
        })
      },

      scrollIntoView(data): void {
        const scrollModifier = window.innerWidth < 1024 ? 30 : 120
        const scrollTo = window.scrollY + target.getBoundingClientRect().top + data.scrollAmount - scrollModifier

        setTimeout(() => {
          lenisScroll.scrollTo(scrollTo, {
            duration: 1.234,
            easing: (t) => (t < 0.5 ? 8 * t ** 4 : 1 - (-2 * t + 2) ** 4 / 2),
            force: true,
          })
        }, 12)
      },

      setHeight(data): void {
        el.iframeContainer.style.height = `${data.iframeHeight}px`
        setTimeout(ScrollTrigger.refresh, 12)
        // setTimeout(method.updateScrollTriggers, 12) // ! This function fires to often and causes performance issues
      },

      updateScrollTriggers(): void {
        let previousBodyHeight = document.body.getBoundingClientRect().height

        const observer = new ResizeObserver((entries) => {
          for (const entry of entries) {
            if (entry.contentRect.height !== previousBodyHeight) {
              previousBodyHeight = entry.contentRect.height
              ScrollTrigger.refresh()
            }
          }
        })

        observer.observe(document.body)
      },
    }

    method.init()
  },
}

export default calculatorBlock
